import { jobs } from "../../../static/jobsData";
import { getActiveJobs, HOMEPAGE_JOB_COUNT } from "../../../static/jobsHelpers";
import "../styles/careers.css";

import Hero from "./01_hero";
import WhyJoin from "./02_whyJoin";
import HiringProcess from "./03_hiringProcess";
// LifeAt (04) and Benefits (08) are currently disabled — same as they were
// commented out in your original single-file CareersLanding.js. Import them
// below and drop them back into the JSX to re-enable:
// import LifeAt from "./04_lifeAt";
import TeamEvents from "./05_teamEvents";  
import CurrentOpenings from "./09_currentOpenings";
import Testimonials from "./10_testimonials";
import Faq from "./11_faq";
import ResumeCta from "./12_resumeCta";

// NOTE: no <header>/<footer> here on purpose — this plugs into your
// existing site Header/Footer. In your router, wrap the route like:
//   <Header /> <CareersLanding /> <Footer />

export default function CareersLanding() {
  const featuredJobs = getActiveJobs(jobs)
    .filter((j) => j.featured)
    .slice(0, HOMEPAGE_JOB_COUNT);

  return (
    <div className="vm-careers">
      <Hero />
      <WhyJoin />
      <HiringProcess /> 
      <TeamEvents />
       
      <CurrentOpenings featuredJobs={featuredJobs} />
    
      <Testimonials />
      <Faq />
      <ResumeCta />
    </div>
  );
}
